export enum EVENT_DETAILS_SECTIONS_Z_INDEXES {
  IMAGE_SECTION = 1,
  SCROLLABLE_CONTENT_SECTION = 2,
  HEADER_AND_FOOTER = 3,
}

export const IMAGE_PLACEHOLDER_HEIGHT = 300;

export const LIMITED_SPOTS_TEXT_THRESHOLD = 10;
